import { 
    ROOT,
    GET_ALL_TRAVEL_AGENT_HOTEL,
    REMOVE_TRAVEL_AGENT_HOTEL,
    GET_TRAVEL_AGENT_HOTEL_INFO,
    UPDATE_AGENT_HOTEL,
    CREATE_AGENT_HOTEL,
    UPDATE_STATUS_AGENT_HOTEL
  } from "@/_helpers/constant.js";
  import { requestOptions, handleResponse } from "@/_helpers";
  

  function getAllTravelAgent(body) {
    return fetch(ROOT + GET_ALL_TRAVEL_AGENT_HOTEL, requestOptions.post(body)).then(handleResponse);
  }
  
  function removeAgent(body) {
    return fetch(ROOT + REMOVE_TRAVEL_AGENT_HOTEL +`?id=${body}`, requestOptions.post()).then(handleResponse);
  }
  
  function getChainTravelAgentInfo(body) {
    return fetch(ROOT + GET_TRAVEL_AGENT_HOTEL_INFO +`?id=${body}`, requestOptions.post()).then(handleResponse);
  }
  
  function updateAgent(data) {
    return fetch(ROOT + UPDATE_AGENT_HOTEL, requestOptions.post(data)).then(handleResponse);
  }
  
  function createAgent(data) {
    return fetch(ROOT + CREATE_AGENT_HOTEL, requestOptions.post(data)).then(handleResponse);
  }

  function updateStatus(data) {
    return fetch(ROOT + UPDATE_STATUS_AGENT_HOTEL, requestOptions.post(data)).then(handleResponse);
  }
  //#endregion
  export const agentService = {
    getAllTravelAgent,
    removeAgent,
    getChainTravelAgentInfo,
    updateAgent,
    createAgent,
    updateStatus
  };
  